import { render, staticRenderFns } from "./EstimateClipboardSections.vue?vue&type=template&id=72706c34&"
import script from "./EstimateClipboardSections.vue?vue&type=script&lang=js&"
export * from "./EstimateClipboardSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports